import { render, staticRenderFns } from "./RoundBadge.html?vue&type=template&id=703e46ee&external"
import script from "./RoundBadge.ts?vue&type=script&lang=ts&external"
export * from "./RoundBadge.ts?vue&type=script&lang=ts&external"
import style0 from "./RoundBadge.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports